import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

interface FormProps {
  onSubmit: (arg0: IFormInputs) => void;
}

interface IFormInputs {
  email: string;
}

const schema = yup
  .object({
    email: yup
      .string()
      .email('Por favor digite um e-mail válido')
      .matches(/^.+@kenzie\.com\.br$/, 'Digite seu e-mail da Kenzie')
      .required(),
  })
  .required();

export function Form({ onSubmit }: FormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInputs>({
    resolver: yupResolver(schema),
  });

  return (
    <form
      className="space-y-6"
      onSubmit={handleSubmit(onSubmit)}
      data-testid="password-recovery-form"
      noValidate
    >
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-[#374151]">
          Email Kenzie
        </label>
        <div className="mt-1">
          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            className="block w-full px-3 py-2 placeholder-gray-400 border border-[#D1D5DB] appearance-none rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            {...register('email')}
          />
        </div>
        <p className="text-[#4B5563] text-[#B91C1C] text-xs h-2 mt-2">{errors.email?.message}</p>
      </div>

      <div>
        <button
          type="submit"
          className="flex justify-center w-full px-4 py-2 text-sm font-medium text-[#ffffff] bg-[#4F46E5] rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Enviar
        </button>
      </div>
    </form>
  );
}
